export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: 'https://www.wuestman.nl',
};
